<template>
  <nav class="app-crumbs" aria-label="Breadcrumb">
    <template v-for="(item, index) in items">
      <router-link
        v-if="item.to"
        :key="`link-${index}`"
        :to="item.to"
        class="app-crumbs__link"
      >
        {{ item.label }}
      </router-link>
      <span v-else :key="`current-${index}`" class="app-crumbs__current">{{ item.label }}</span>

      <i
        v-if="index < items.length - 1"
        :key="`sep-${index}`"
        class="fa-regular fa-chevron-right app-crumbs__sep"
        aria-hidden="true"
      ></i>
    </template>
  </nav>
</template>

<script>
/**
 * Breadcrumb trail. Items shape: [{ label: string, to?: string|object }] —
 * items with `to` render as router-links, the rest (usually the last one)
 * as plain text.
 */
export default {
  name: 'AppBreadcrumbs',

  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
// Self-contained tokens — mirrors the admin palette without importing it.
$crumbs-text-subtle: #8a96a3;
$crumbs-blue:        #1f73c1;

.app-crumbs {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: $crumbs-text-subtle;
  min-width: 0;

  &__link {
    color: $crumbs-blue;
    text-decoration: none;
    font-weight: 500;
    white-space: nowrap;

    &:hover { text-decoration: underline; }
  }

  &__sep {
    font-size: 9px;
    opacity: .6;
  }

  &__current {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }
}
</style>
